import { useState } from "react"
const Modal = ({isActive,closeModal,filterDate,activateFilter,showToast})=>{
    const [filter,setFilter] = useState('')
    const fitlerMethod = () =>{
        if(!filter){
            showToast('error','Please select a date!')
            return
        }
        filterDate(filter)
        activateFilter(true)
        closeModal()
    }
    return (
        <div className={isActive ? "modal is-active" : "modal"}>
            <div className="modal-background"></div>
            <div className="modal-card">
                <header className="modal-card-head">
                    <p className="modal-card-title has-text-centered">Filter By Created Date</p>
                    <button className="delete" aria-label="close" onClick={closeModal}></button>
                </header>
                <section className="modal-card-body is-expanded" >
                    <p className="is-size-6	has-text-centered">Select a date to filter</p>
                    <input type="date" onChange={(event)=>{setFilter(event.target.value)}} value={filter} style={{display:"table-cell" ,width:"100%"}}/>
                </section>
                <footer className="modal-card-foot">
                    <button className="button is-success" onClick={fitlerMethod}>Filter</button>
                    <button className="button" onClick={closeModal}>Cancel</button>
                </footer>
            </div>
        </div>
    )
}

export default Modal